/* ── Bara Bros Cart Coupon Reminder — bb-cart-coupon-reminder.js ── */
(function () {
  'use strict';

  if (window.__bbCCRLoaded) return;
  window.__bbCCRLoaded = true;

  var PAGE_DATA_URL = '/apps/bb-wishlist/coupons/page-data';
  var CART_URL      = '/cart.js';

  /* Cached page data — fetched once, reused */
  var _pageData   = null;
  var _pageDataOk = false;

  /* All reminder containers on the page (drawer + main cart) */
  var containers = [];

  /* ── Normalised value for a campaign coupon (uses discount_type/discount_value) ── */
  function normalizedValue(coupon, subtotalCents) {
    var v = parseFloat(coupon.discount_value) || 0;
    if (coupon.discount_type === 'percentage') return subtotalCents * v / 100;
    return v * 100;
  }

  /* ── Normalised value for a wallet coupon (uses type/value) ── */
  function walletCouponValue(coupon, subtotalCents) {
    var v = parseFloat(coupon.value) || 0;
    if (coupon.type === 'percentage') return subtotalCents * v / 100;
    return v * 100;
  }

  /* ── Pick the single best coupon to surface ──
     walletUnused  — unused wallet coupons (eligible if they meet min order)
     campaigns     — public campaigns not yet in wallet (for collect/near-unlock)
     walletIds     — Set of all coupon ids in the wallet (to skip already-claimed)
  ── */
  function pickBest(walletUnused, campaigns, walletIds, subtotalCents, minUnlockDistance) {
    var eligible   = [];
    var collectible = [];
    var nearUnlock = [];

    /* Eligible: wallet unused coupons that meet minimum order */
    (walletUnused || []).forEach(function (c) {
      if (!c) return;
      var minOrder = (parseFloat(c.minimum_order || c.min_order_amount) || 0) * 100;
      if (subtotalCents >= minOrder) {
        eligible.push({ coupon: c, value: walletCouponValue(c, subtotalCents) });
      }
    });

    /* Collect / near-unlock: campaigns the customer hasn't saved yet */
    (campaigns || []).forEach(function (c) {
      if (!c || !c.id) return;
      if (walletIds.has(String(c.id))) return;
      var minOrder = (parseFloat(c.min_order_amount) || 0) * 100;
      var meetsMin = subtotalCents >= minOrder;
      var gap      = minOrder - subtotalCents;

      if (meetsMin) {
        collectible.push({ coupon: c, value: normalizedValue(c, subtotalCents) });
      } else if (gap > 0 && gap <= minUnlockDistance * 100) {
        nearUnlock.push({ coupon: c, gap: gap, minOrder: minOrder });
      }
    });

    function byValue(a, b) {
      if (b.value !== a.value) return b.value - a.value;
      var expA = a.coupon.end_date || a.coupon.expires_at;
      var expB = b.coupon.end_date || b.coupon.expires_at;
      var ea   = expA ? new Date(expA).getTime() : Infinity;
      var eb   = expB ? new Date(expB).getTime() : Infinity;
      return ea - eb;
    }

    eligible.sort(byValue);
    collectible.sort(byValue);
    nearUnlock.sort(function (a, b) { return a.gap - b.gap; });

    if (eligible.length)    return { state: 'eligible',    item: eligible[0] };
    if (collectible.length) return { state: 'collect',     item: collectible[0] };
    if (nearUnlock.length)  return { state: 'near_unlock', item: nearUnlock[0] };
    return null;
  }

  /* ── Format cents as "$X.XX" (or "$X" when no cents) ── */
  function formatMoney(cents) {
    var dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  /* ── Build inner HTML for a given best-pick result ── */
  function buildHTML(best, cfg) {
    if (!best) return '';

    var coupon = best.item.coupon;
    var code   = coupon.code || '';
    var title  = cfg.title || 'Your Coupons';

    if (best.state === 'eligible') {
      var copyBtn = cfg.showCopy
        ? '<button class="bb-ccr__copy-btn" data-bb-ccr-copy="' + escAttr(code) + '" type="button">Copy Code</button>'
        : '';
      var pasteNote = cfg.showCopy ? '<span class="bb-ccr__paste-note">Paste at checkout</span>' : '';
      return (
        '<div class="bb-ccr__inner">' +
          '<span class="bb-ccr__title">' + escHTML(title) + '</span>' +
          '<div class="bb-ccr__code-row">' +
            '<code class="bb-ccr__code">' + escHTML(code) + '</code>' +
            copyBtn +
          '</div>' +
          pasteNote +
        '</div>'
      );
    }

    if (best.state === 'collect') {
      var popupBtn = cfg.showPopup
        ? '<button class="bb-ccr__popup-btn" data-bb-open-coupon-popup type="button">Collect Coupons</button>'
        : '<a class="bb-ccr__popup-btn" href="' + escAttr(cfg.fallbackUrl) + '">Collect Coupons</a>';
      return (
        '<div class="bb-ccr__inner">' +
          '<span class="bb-ccr__title">' + escHTML(title) + '</span>' +
          '<p class="bb-ccr__msg">Collect coupons before checkout and save more.</p>' +
          popupBtn +
        '</div>'
      );
    }

    if (best.state === 'near_unlock') {
      var gap       = best.item.gap;
      var minOrder  = best.item.minOrder;
      var progress  = Math.max(0, Math.min(100, Math.round((1 - gap / minOrder) * 100)));
      var progressBar = cfg.showProgress
        ? '<div class="bb-ccr__progress-track"><div class="bb-ccr__progress-fill" style="width:' + progress + '%"></div></div>'
        : '';
      var desc = coupon.discount_type === 'percentage'
        ? Math.round(parseFloat(coupon.discount_value) || 0) + '% off'
        : formatMoney((parseFloat(coupon.discount_value) || 0) * 100) + ' off';
      return (
        '<div class="bb-ccr__inner">' +
          '<span class="bb-ccr__title">' + escHTML(title) + '</span>' +
          '<p class="bb-ccr__msg">Add <strong>' + escHTML(formatMoney(gap)) + '</strong> more to unlock <strong>' + escHTML(desc) + '</strong> with code <strong>' + escHTML(code) + '</strong>.</p>' +
          progressBar +
        '</div>'
      );
    }

    return '';
  }

  function escHTML(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escAttr(s) { return escHTML(s); }

  /* ── Build HTML from personalized cart_nudge (fallback when pickBest finds nothing) ── */
  function buildPersonalizedHTML(nudge, cfg) {
    if (!nudge || !nudge.enabled || !nudge.message) return '';
    var popupBtn = cfg.showPopup
      ? '<button class="bb-ccr__popup-btn" data-bb-open-coupon-popup type="button">' + escHTML(nudge.cta || 'View Coupons') + '</button>'
      : '<a class="bb-ccr__popup-btn" href="' + escAttr(cfg.fallbackUrl) + '">' + escHTML(nudge.cta || 'View Coupons') + '</a>';
    return (
      '<div class="bb-ccr__inner bb-ccr__inner--personalized">' +
        '<span class="bb-ccr__title">' + escHTML(cfg.title || 'Your Coupons') + '</span>' +
        '<p class="bb-ccr__msg">' + escHTML(nudge.message) + '</p>' +
        popupBtn +
      '</div>'
    );
  }

  /* ── Render all containers ── */
  function renderAll(subtotalCents) {
    if (!_pageDataOk || !_pageData) {
      containers.forEach(function (el) { el.style.display = 'none'; });
      return;
    }

    var walletUnused = (_pageData.groups && _pageData.groups.unused) || [];
    var campaigns    = _pageData.campaigns || [];
    var walletIds    = new Set(
      (_pageData.wallet && _pageData.wallet.coupons ? _pageData.wallet.coupons : [])
        .map(function (c) { return String(c.id); })
    );
    var cartNudge = (_pageData.personalized_rewards && _pageData.personalized_rewards.cart_nudge) || null;

    containers.forEach(function (el) {
      var cfg = readCfg(el);
      var best = pickBest(walletUnused, campaigns, walletIds, subtotalCents, cfg.minUnlockDistance);
      var html = buildHTML(best, cfg);

      /* Fallback to personalized cart_nudge when existing logic has nothing to show */
      if (!html && cartNudge && cartNudge.enabled) {
        html = buildPersonalizedHTML(cartNudge, cfg);
      }

      if (!html) {
        el.style.display = 'none';
        el.innerHTML = '';
        return;
      }

      el.innerHTML = html;
      el.style.display = '';

      /* Wire copy button */
      var copyBtn = el.querySelector('[data-bb-ccr-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = copyBtn.getAttribute('data-bb-ccr-copy');
          copyToClipboard(code, copyBtn);
        });
      }
    });
  }

  function readCfg(el) {
    return {
      title:            el.getAttribute('data-title')           || 'Your Coupons',
      style:            el.getAttribute('data-style')           || 'compact',
      showProgress:     el.getAttribute('data-show-progress')   !== 'false',
      showCopy:         el.getAttribute('data-show-copy')       !== 'false',
      showPopup:        el.getAttribute('data-show-popup')      !== 'false',
      minUnlockDistance: parseInt(el.getAttribute('data-min-unlock-distance') || '500', 10),
      fallbackUrl:      el.getAttribute('data-fallback-url')    || '/pages/coupons'
    };
  }

  function copyToClipboard(text, btn) {
    var original = btn.textContent;
    function confirm() { btn.textContent = 'Copied!'; setTimeout(function () { btn.textContent = original; }, 2000); }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(confirm).catch(function () { fallbackCopy(text, confirm); });
    } else {
      fallbackCopy(text, confirm);
    }
  }

  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0';
    document.body.appendChild(ta);
    ta.focus(); ta.select();
    try { document.execCommand('copy'); done(); } catch (e) { /* silent */ }
    document.body.removeChild(ta);
  }

  /* ── Fetch page data (once) ── */
  function fetchPageData(cb) {
    if (_pageDataOk) { cb(); return; }
    fetch(PAGE_DATA_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        _pageData = data; _pageDataOk = true;
        /* Expiring coupon notification — once per session */
        if (window.BBRewardNotifications && data && data.logged_in) {
          var expiring = (data.groups && data.groups.expiring_soon) || [];
          if (expiring.length > 0) {
            window.BBRewardNotifications.show('coupon_expiring', { expires_in: expiring.length + ' coupon' + (expiring.length > 1 ? 's' : '') });
          }
        }
        cb();
      })
      .catch(function () { /* fail silently */ cb(); });
  }

  /* ── Fetch cart subtotal ── */
  function fetchCartAndRender() {
    fetch(CART_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (cart) { renderAll(cart.total_price || 0); })
      .catch(function () { renderAll(0); });
  }

  /* ── Debounce ── */
  var _debTimer = null;
  function debounce(fn, ms) {
    clearTimeout(_debTimer);
    _debTimer = setTimeout(fn, ms);
  }

  function refresh() {
    fetchPageData(function () { fetchCartAndRender(); });
  }

  /* ── MutationObserver: detect AJAX cart item changes ── */
  function observeCartItems() {
    var targets = [
      document.getElementById('CartDrawer-CartItems'),
      document.getElementById('cart-items'),
      document.querySelector('[data-cart-items]')
    ].filter(Boolean);

    if (!targets.length) return;

    var observer = new MutationObserver(function () {
      debounce(refresh, 400);
    });
    targets.forEach(function (t) {
      observer.observe(t, { childList: true, subtree: true, characterData: true });
    });
  }

  /* ── Cart events (theme-fired) ── */
  function bindCartEvents() {
    ['cart:refresh', 'cart:change', 'cart:updated', 'sections:refreshed'].forEach(function (name) {
      document.addEventListener(name, function () { debounce(refresh, 300); });
    });
    /* Cart drawer open */
    document.addEventListener('cart-drawer:open', function () { debounce(refresh, 200); });
  }

  /* ── Boot ── */
  function boot() {
    containers = Array.from(document.querySelectorAll('[data-bb-cart-coupon-reminder]'));
    if (!containers.length) return;

    observeCartItems();
    bindCartEvents();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
